import styled from "@emotion/styled";
import { Skeleton, Variables } from "@repo/skapa";
import { CardContainer, FlexDiv } from "@repo/ui";

import { CARD_HEIGHT_NORMAL } from "./constants";

export const ScrollContainer = styled.div<{ overflowY?: string }>`
  height: 100%;
  overflow-y: ${(props) => (props.overflowY ? props.overflowY : "scroll")};
`;

export const WidgetContainer = styled(CardContainer)<{ size: number }>`
  display: flex;
  flex-direction: column;

  height: 100%;
  min-height: ${CARD_HEIGHT_NORMAL}px;
  max-height: ${(props) => `${props.size}px`};

  padding: ${Variables.space75};

  gap: ${Variables.space75};

  @media (min-width: ${Variables.breakpointM}) {
    gap: ${Variables.space100};
    padding: ${Variables.space150};
  }
`;

export const CardTableLoader = () => {
  return (
    <FlexDiv gap="2px" flexDirection="column">
      {[1, 2, 3, 4, 5].map((o) => {
        return <Skeleton key={o} height="48px" width="100%" />;
      })}
    </FlexDiv>
  );
};
